import { render, staticRenderFns } from "./TqAvatar.vue?vue&type=template&id=1ace7320&scoped=true&"
import script from "./TqAvatar.vue?vue&type=script&lang=js&"
export * from "./TqAvatar.vue?vue&type=script&lang=js&"
import style0 from "./TqAvatar.vue?vue&type=style&index=0&id=1ace7320&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ace7320",
  null
  
)

export default component.exports